var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationManGlasses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M45 43h2v-7h-2zM33 43h2v-7h-2zM22 72h2v-8h-2zM56 72h2v-8h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 40c-6.346 0-10.808-7.07-10.994-13.58l-.713-.713A.996.996 0 0128 25v-5h2v4.586l.707.707A.996.996 0 0131 26c0 5.676 3.696 12 9 12s9-6.324 9-12c0-.266.105-.52.293-.707l.707-.707V20h2v5c0 .266-.105.52-.293.707l-.713.713C50.808 32.93 46.346 40 40 40",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 20c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zM45 20c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M38 23h4v-2h-4zM32 23h-1c-1.654 0-3-1.346-3-3h2c0 .552.449 1 1 1h1v2M49 23h-1v-2h1c.551 0 1-.448 1-1h2c0 1.654-1.346 3-3 3",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 19h-2v-2c0-6.495-6.889-7-9-7-2.111 0-9 .505-9 7v2h-2v-2c0-5.552 4.215-9 11-9s11 3.448 11 9v2M45 32h-2c0-.552-.449-1-1-1h-4c-.551 0-1 .448-1 1h-2c0-1.654 1.346-3 3-3h4c1.654 0 3 1.346 3 3M40 45c-5.701 0-10-2.149-10-5h2c0 1.224 3.117 3 8 3s8-1.776 8-3h2c0 2.851-4.299 5-10 5",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 49c-5.333 0-11-1.752-11-5a1 1 0 112 0c0 1.224 3.506 3 9 3s9-1.776 9-3a1 1 0 112 0c0 3.248-5.667 5-11 5",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 72h-2V59c0-7.4 5.658-10.265 10.616-11.926l5.772-2.886C28.746 43.775 30 42.174 30 40h2c0 3.375-2.199 5.613-2.293 5.707l-.115.115-6.276 3.126C16.699 51.154 14 54.066 14 59v13M68 72h-2V59c0-4.934-2.699-7.846-9.316-10.052l-.131-.053-6.145-3.073-.115-.115C50.199 45.613 48 43.375 48 40h2c0 2.196 1.248 3.775 1.61 4.187l5.774 2.887C62.342 48.735 68 51.6 68 59v13",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationManGlasses;